import { useTranslation } from "react-i18next"
import { MILLISECONDS_IN_DAY, MILLISECONDS_IN_HOUR, MILLISECONDS_IN_MINUTE } from "@/lib/format-date"

const getDurationToNow = (dateTime: Date): number => {
  return new Date().getTime() - new Date(dateTime).getTime()
}

export const formatEpisodeOfCareDuration = (updatedAt: Date, { t }: ReturnType<typeof useTranslation>) => {
  const now = new Date()
  const duration = getDurationToNow(updatedAt)
  const minutes = Math.floor(duration / MILLISECONDS_IN_MINUTE)
  const hours = Math.floor(duration / MILLISECONDS_IN_HOUR)
  const days = Math.floor(duration / MILLISECONDS_IN_DAY)
  const months = now.getMonth() - updatedAt.getMonth()
  const years = now.getFullYear() - updatedAt.getFullYear()

  if (minutes < 1) return t("episodeOfCare.duration.lessThanAMinute")
  if (minutes >= 1 && hours < 1) return t("episodeOfCare.duration.minute", { count: minutes })
  if (hours >= 1 && days < 1) return t("episodeOfCare.duration.hour", { count: hours })
  if (days >= 1 && days < 30) return t("episodeOfCare.duration.day", { count: days })
  if (days >= 30 && years < 1) return t("episodeOfCare.duration.month", { count: months })
  return t("episodeOfCare.duration.year", { count: years })
}
